import { AssetAttributes, AssetGroupAttributes, CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from 'app/utils/method';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { ICreateAsset } from './interfaces/create-asset.interface';
import { AssetService } from './asset.service';
import { IUpdateAsset } from './interfaces/update-asset.interface';
import { AssetGroupService } from './asset-group/asset-group.service';
import { CompanyService } from '../configuration/company/company.service.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { ConfigurationFiltersComponent } from '../filters/configuration-filters/configuration-filters.component';
import { StatusFiltersComponent } from '../filters/status-filters/status-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-asset',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './asset.component.html',
  styleUrl: './asset.component.scss'
})
export class AssetComponent implements OnDestroy{
  getCode = getCode
  displayedColumns: string[] = [
    "name", 
    "quantity",
    "statusId", 
    "action"
  ];

  dataSource = new MatTableDataSource<AssetAttributes>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof AssetAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  filter = {
    group: [],
    type: null
  }

  groupList: AssetGroupAttributes[] = []
  groupFilterList: AssetGroupAttributes[] = [] 

   companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []

  currentAsset: ICreateAsset = this.initializeCreateAsset();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;

  selectedStatuses: [] = [];

  // Lazy loading flags
  loadFiltersData = false;

  constructor(
    private assetService: AssetService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private assetGroupService: AssetGroupService,
    private companyService: CompanyService,
    private readonly searchService: SearchService,
    private fb: FormBuilder
  ) { 
    this.form = this.fb.group({
      companyId: [],
      groupActiveId: []
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.onFilter();
  }

  onFilter(){
    this.getList()
  }

  clearFilters(): void {
    this.selectedStatuses = [];
    this.form.reset();
    this.onFilter();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    if (!this.groupList.length) {
      this.getAllGroup();
    }
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    let send = {
      group: this.filter.group,
      type: this.filter.type,
    }

    this.assetService.getAllPaginateAsset(options, 
      send,
      this.selectedStatuses,
      this.form.get("companyId")?.value,
      this.form.get("groupActiveId")?.value,
    ).subscribe({
      next: (res: IPaginationResult<AssetAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener Condiciones de Cambio","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateAsset(): ICreateAsset {
    return { 
      code: "", 
    //   externalKeys: {code: null},
      name: "", 
      quantity: 0,
      loadCapacity: 0,
      assetGroupId: []
    };
  }

  getAllGroup(): void {
    this.assetGroupService.findToComboBox().subscribe({
      next: (res: IRequestResult<AssetGroupAttributes[]>) => {
        this.groupList = res.data;
        this.groupFilterList = this.groupList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error fetching group',"Cerrar",{ duration: 5000});
      }
    });
  }


    getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error fetching companies',"Cerrar",{ duration: 5000});
      }
    });
  }


  openModal(asset?: AssetAttributes): void {
    this.getAllGroup();
    this.getAllCompanies();
    if(asset){
      this.currentAsset = {
        ...asset,
        assetGroupId: asset.assetGroup.map(a=>a._id.toString()),
        companiesIds: asset?.companies?.map(a => a._id?.toString()) ?? null
        // excode: asset.externalKeys?.code ?? null,
      };
      this.id = asset._id
    }else{
      this.currentAsset = this.initializeCreateAsset();
      this.id = null
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '90%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit(){
    if(this.id == null){
      this.createAsset()
    }else{
      this.updateAsset(this.id)
    }
  }

  createAsset(): void {
    const createAsset: ICreateAsset = { 
      ...this.currentAsset, 
    //   externalKeys: this.currentAsset.excode ? {code: this.currentAsset.excode} : null
    };

    this.assetService.create(createAsset).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateAsset(id: string): void {
   if (this.currentAsset) {
      const updatedAsset: IUpdateAsset = { 
        ...this.currentAsset,
      };

      this.assetService.update(id, updatedAsset).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if(this.dialogRef){
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, asset: AssetAttributes, type?: string): void {
    const originalStatusId = asset.statusId;
    const updatedStatusId = type == 'S' ? (event ? 1 : 0): originalStatusId;

    const updateAsset = { 
      //...returnType, 
      statusId: updatedStatusId,
    };

    this.assetService.update(asset._id.toString(), updateAsset).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        asset.statusId = originalStatusId; 

        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(returnType: AssetAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: returnType, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(returnType._id.toString()));
  }

  delete(id: string): void {
    this.assetService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
